<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      {{ copyrightPrefix }}
      <b-link class="ml-25" :href="siteUrl" target="_blank">{{ siteName }}</b-link>
      <span class="d-none d-sm-inline-block">, All rights Reserved</span>
    </span>

    <span class="float-md-right d-none d-md-block">
      {{ footerCreditText }}
      <feather-icon
        v-if="showFooterHeart"
        icon="HeartIcon"
        size="21"
        class="text-danger stroke-current"
      />
    </span>
  </p>
</template>

<script>
import { BLink } from "bootstrap-vue";
import axios from "@/helpers/axios";

export default {
  components: {
    BLink,
  },
  data() {
    return {
      settings: {},
    };
  },
  computed: {
    siteName() {
      return this.settings.site_name || this.settings.business_name || "Masud Telecomm";
    },
    siteUrl() {
      return this.settings.site_url || "/";
    },
    copyrightPrefix() {
      return `COPYRIGHT © ${new Date().getFullYear()}`;
    },
    footerCreditText() {
      return this.settings.admin_footer_credit_text || "Hand-crafted & Made with";
    },
    showFooterHeart() {
      const value = this.settings.admin_footer_show_heart;
      return !(value === "0" || value === 0 || value === false || value === "false");
    },
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    async loadSettings() {
      try {
        const { data } = await axios.get("/api/v1/admin/business-settings");
        this.settings = data || {};
      } catch (error) {
        this.settings = {};
      }
    },
  },
};
</script>
